export const validatePhoneNumber = (phone:string) => {
  // Indian phone number regex: starts with 6-9 and followed by 9 digits
  const phoneRegex = /^[6-9]\d{9}$/;
  return phoneRegex.test(phone);
};

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};